module.exports = __webpack_public_path__ + "img/chris.dadcce1a.png";